var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 113.2",
    style: {
      enableBackground: "new 0 0 122.88 113.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#EC672A;} .st1{fill:#DD3E2A;} .st2{fill:#F6A420;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.65,64.72l-6.89-21.15L102.15,1.61c-0.7-2.15-3.74-2.15-4.47,0L84.06,43.54H38.81L25.19,1.61 c-0.7-2.15-3.74-2.15-4.47,0L7.13,43.54L0.24,64.72c-0.62,1.92,0.05,4.04,1.7,5.24l59.5,43.23l59.5-43.23 C122.58,68.77,123.28,66.65,122.65,64.72L122.65,64.72z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "61.45,113.17 61.45,113.17 84.08,43.54 38.82,43.54 61.45,113.17 61.45,113.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.43,113.17 38.81,43.54 7.13,43.54 61.43,113.17 61.43,113.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.11,43.56L7.11,43.56L0.23,64.72c-0.62,1.92,0.05,4.04,1.7,5.24l59.5,43.23L7.11,43.56L7.11,43.56 L7.11,43.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.12,43.56h31.71L25.18,1.63c-0.7-2.15-3.74-2.15-4.47,0L7.12,43.56L7.12,43.56L7.12,43.56z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.45,113.17 84.08,43.54 115.79,43.54 61.45,113.17 61.45,113.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.76,43.56L115.76,43.56l6.89,21.15c0.62,1.92-0.05,4.04-1.7,5.24l-59.5,43.21L115.76,43.56L115.76,43.56 L115.76,43.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.78,43.56H84.07L97.69,1.63c0.7-2.15,3.74-2.15,4.47,0L115.78,43.56L115.78,43.56L115.78,43.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGitlab);
export default __webpack_public_path__ + "static/media/icon_gitlab.f1e5937a752e343dbec72adf0e36bbf9.svg";
export { ForwardRef as ReactComponent };